// Import necessary dependencies
import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from "styleguide/lib/merge-options";

// Define plugin name and default options
export const PLUGIN_NAME = 'stateSearch';
export const DEFAULTS = {
    shippingZipCode: "",
};

// List of states and their respective zip codes (for demonstration purposes)
const states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California, 90703',
    'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii',
    'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
    'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
    'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
    'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
    'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

/**
 * Extracts the zip code from a given suggestion string.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @returns {string} - Extracted zip code value.
 */
const getZipCodeValue = (suggestion) => {
    const values = suggestion.split(",");
    const lastValue = values[values.length - 1].trim(); // Get and trim the last element
    return lastValue;
};

/**
 * Fills the zip code input field based on the selected suggestion.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @param {Object} opts - Options object containing the zip code input field ID.
 */
const fillZipCode = (suggestion, opts) => {
    const { zipCodeInput } = opts;
    const $shippingZipCodeInput = $(`#${zipCodeInput}`);
    const zipCode = getZipCodeValue(suggestion);
    $shippingZipCodeInput.val(zipCode);
};

/**
 * Creates a substring matcher for the typeahead functionality.
 * @param {Array<string>} strs - List of strings to match against.
 * @returns {function} - A function that returns matches for a given query.
 */
const substringMatcher = (strs) => {
    return function findMatches(query, callback) {
        const matches = [];
        const substrRegex = new RegExp(query, 'i'); // Case-insensitive regex for matching

        // Find all strings containing the query
        $.each(strs, (i, str) => {
            if (substrRegex.test(str)) {
                matches.push(str);
            }
        });

        callback(matches); // Return matches via the callback
    };
};

/**
 * Initializes the typeahead functionality on a given element.
 * @param {jQuery} $el - The jQuery-wrapped element to initialize the typeahead on.
 * @param {Object} opts - Options object containing configurations.
 */
const initializeTypeahead = ($el, opts) => {
    $(`.js-state-search-container .js-state-search`).typeahead(
        {
            hint: true,
            highlight: true,
            minLength: 1,
        },
        {
            name: 'states',
            source: substringMatcher(states),
        }
    );

    // Bind the select event to populate the zip code field
    $('.js-state-search').on('typeahead:select', (ev, suggestion) => {
        fillZipCode(suggestion, opts);
    });
    $('.js-state-search').on('typeahead:autocomplete', (ev, suggestion) => {
        fillZipCode(suggestion, opts);
    });
};

/**
 * Main function to initialize the state search plugin.
 * @param {HTMLElement} el - The container element for the plugin.
 * @param {Object} options - Configuration options for the plugin.
 */
export default function stateSearch(el, options) {
    const $el = $(el); // Convert the element to a jQuery object
    const opts = mergeOptions(DEFAULTS, options, $el); // Merge default and provided options
    initializeTypeahead($el, opts); // Initialize the typeahead functionality
}

// Register the plugin with jQuery
registerJQueryPlugin(PLUGIN_NAME, stateSearch);



// WEBPACK FOOTER //
// ./src/scripts/modules/state-search.js